module.exports = __webpack_public_path__ + "static/media/DLine1-4.ac017875.png";